module.exports = __webpack_public_path__ + "static/media/done-icon.5c59561a.svg";